<template>
    <div>
        <RouteLoader />
        <main class="main">
            <RouterView v-if="initialLoadComplete" />
        </main>
        <Footer v-if="showNavigation" />
        <AppLoader v-if="isAppLoading" />
    </div>
</template>

<script setup lang="ts">
import AppLoader from '@/components/layout/AppLoader.vue'
import Footer from '@/components/layout/Footer.vue'
import RouteLoader from '@/components/layout/RouteLoader.vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const showNavigation = computed(() => route.name !== 'login')

const isAppLoading = ref(true)
const initialLoadComplete = ref(false)

onMounted(async () => {
    const minDelayMs = 1500
    const minDelay = new Promise<void>((resolve) => setTimeout(resolve, minDelayMs))
    const waitForWindowLoad = new Promise<void>((resolve) => {
        if (document.readyState === 'complete') {
            resolve()
        } else {
            window.addEventListener('load', () => resolve(), { once: true })
        }
    })

    const routerReady = router.isReady ? router.isReady() : Promise.resolve()
    await Promise.all([routerReady, waitForWindowLoad, minDelay])
    initialLoadComplete.value = true
})

watch(
    initialLoadComplete,
    (complete) => {
        if (complete && isAppLoading.value) {
            setTimeout(() => {
                isAppLoading.value = false
            }, 300)
        }
    },
    { immediate: true }
)
</script>
